import clientFirebase from "config/firebase_client";


    
  
      const get_data=()=>{

        console.log("it's action function");
        return (dispatch)=>{  

            clientFirebase.firestore().collection('All_Hotel').
            where('adminUID', '==', localStorage.getItem('admin_uid'))
            .onSnapshot((querySnapshot) => {
              var all = [];
              querySnapshot.forEach((doc) => {
                all.push(doc.data());
                  // console.log("Current cities in CA: ", doc.data());
              });
              
              dispatch(
                {
                  type: "hotel"
                  ,  payload:all
                })
              });
              
              setTimeout(() => {
                document.getElementById('loadingSHOW').style.display='none'
              
              }, 3000);
          
                
                };


          
      
          
         
        }
  
  
  
  
    //  *********************************************************************************
  
  
  















// ================================================================











export {
  

  get_data
  
  }

    
   